var selectors = {
  hamburgerMenu: '[data-hamburger-menu]',
  mobileNavigation: '[js-mobile-navigation]',
  parentLinks: '[js-mobile-link]',
  childNavigation: '[js-child-navigation]',
  parentNavigation: '[js-parent-navigation]',
  backButton: '[js-back-button]'
}

const hamburgerMenu = document.querySelector(selectors.hamburgerMenu);
const mobileNavigation = document.querySelector(selectors.mobileNavigation);
const parentLinks = document.querySelectorAll(selectors.parentLinks);
const parentNavigation = document.querySelector(selectors.parentNavigation);
const childNavigation = document.querySelector(selectors.childNavigation);
const backButtons = document.querySelectorAll(selectors.backButton);

if (hamburgerMenu) {
  hamburgerMenu.addEventListener('click', (e) => {
    e.preventDefault();

    if (mobileNavigation) {
      if (mobileNavigation.classList.contains('active')) {
        mobileNavigation.classList.remove('active');
        document.body.parentNode.classList.remove('stop-scroll');
      } else {
        if (parentNavigation) parentNavigation.classList.remove('hidden');
        if (childNavigation) childNavigation.classList.remove('active');
        mobileNavigation.classList.add('active');
        document.body.parentNode.classList.add('stop-scroll');
      }
    }
  });
}

backButtons.forEach(button => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    if (parentNavigation) parentNavigation.classList.remove('hidden');
    if (childNavigation) childNavigation.classList.remove('active');

    const items = document.querySelectorAll('[js-mobile-content]');
    items.forEach(item => {
      item.classList.add('hidden');
    });
  });
});

parentLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();

    if (childNavigation) childNavigation.classList.add('active');
    if (parentNavigation) parentNavigation.classList.add('hidden');

    const title = link.getAttribute('data-title');
    const items = document.querySelectorAll('[js-mobile-content]');

    mobileNavigation.scrollTo(0, 0);

    items.forEach(item => {
      const itemTitle = item.getAttribute('data-title');

      if (title == itemTitle) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
  });
});